/* ==========================================================================
   ALMAM - completari la drawerul cosului
   ==========================================================================
   Doua lucruri, amandoua lipsa din tema si niciunul reparabil din fisierele ei
   fara sa le modific:

   1. numarul de produse din antet si bara de livrare gratuita, care trebuie sa
      se schimbe odata cu cosul;
   2. inchiderea panourilor de nota si de livrare la apasare in afara lor.

   Primul e explicat imediat mai jos, al doilea la locul lui, mai jos in fisier.

   -- 1. Numarul de produse si bara de livrare --------------------------------
   Cele doua elemente trebuie sa se schimbe odata cu cosul, dar niciunul nu e
   in lista sectiunilor pe care le reimprospateaza tema:
   `assets/cart-notification.js` are lista scrisa in cod, in
   `getSectionsToRender`, si nu se poate adauga la ea fara sa modific fisierul
   temei - care s-ar pierde la o actualizare.

   Solutia: cer eu sectiunea `cart-notification-progress` de fiecare data cand
   se schimba cosul. Textul, pluralul romanesc si suma raman formatate de
   platforma, in loc sa fie construite aici, unde ar fi trebuit duplicate din
   Liquid si tinute in acord cu el.

   Numarul de produse calatoreste pe acelasi raspuns, ca `data-count`, deci o
   singura cerere le acopera pe amandoua.

   Declansarea e un observator pe lista de produse: tema o rescrie la ORICE
   schimbare a cosului - adaugare, plus, minus, stergere - pe cai diferite din
   cod, dintre care unele nu anunta nimic. Un semn pe care il lasa toate e mai
   sigur decat sa ma leg de fiecare cale in parte.
   ========================================================================== */

(function () {
  'use strict';

  var PROGRESS_ID = 'cart-drawer-progress';
  var ITEMS_ID = 'cart-notification-product';
  var SECTION = 'cart-notification-progress';

  function sectionInnerHTML(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var wrapper = doc.querySelector('.shopify-section');
    return wrapper ? wrapper.innerHTML : html;
  }

  function applyCount(host) {
    var data = host.querySelector('[data-count]');
    if (!data) return;

    var count = data.getAttribute('data-count');
    Array.prototype.forEach.call(
      document.querySelectorAll('[data-cart-drawer-count]'),
      function (el) {
        el.textContent = '(' + count + ')';
      }
    );
  }

  var inFlight = false;
  var again = false;

  function refresh() {
    var host = document.getElementById(PROGRESS_ID);
    if (!host) return;

    /* Doua schimbari apropiate (apasari repetate pe plus) nu trebuie sa dea doua
       cereri care se pot intoarce in ordine inversa si sa lase afisata starea
       veche. Cat una e pe drum, a doua doar noteaza ca mai trebuie una. */
    if (inFlight) {
      again = true;
      return;
    }
    inFlight = true;

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    fetch(root + '?sections=' + SECTION)
      .then(function (r) {
        return r.json();
      })
      .then(function (json) {
        if (typeof json[SECTION] !== 'string') return;
        host.innerHTML = sectionInnerHTML(json[SECTION]);
        applyCount(host);
      })
      .catch(function () {
        /* O cerere esuata nu trebuie sa lase drawerul rupt: raman datele vechi,
           iar urmatoarea schimbare a cosului incearca din nou. */
      })
      .then(function () {
        inFlight = false;
        if (again) {
          again = false;
          refresh();
        }
      });
  }

  var timer = null;
  function scheduleRefresh() {
    if (timer) clearTimeout(timer);
    timer = setTimeout(refresh, 80);
  }

  /* ------------------------------------------------------------------------
     Panourile de nota si de livrare se inchid la apasare in afara lor
     ------------------------------------------------------------------------
     `assets/cart_drawer_action.js` le deschide si le inchide DOAR din butoane:
     „Nota" / „Livrare" ca sa le deschida, „Salveaza" / „Anuleaza" ca sa le
     inchida. Valul alb care apare peste cos cat panoul e deschis nu asculta
     nimic, desi arata exact ca o suprafata de apasat.

     Ascultarea sta pe document, nu pe val: apasarea poate cadea si pe restul
     drawerului, si in afara lui, iar toate trei inseamna acelasi lucru - am
     terminat cu panoul.

     Butoanele care DESCHID panoul sunt scoase din calcul: ascultatorul temei e
     pe buton, al meu pe document, deci al meu ruleaza al doilea, pe aceeasi
     apasare, si ar inchide la loc panoul tocmai deschis. */
  var PANEL_SELECTOR = '.notification_action_drawer';
  var OPEN_BUTTON_SELECTOR = '.cart_notification_action_button';

  function openPanels() {
    return document.querySelectorAll(PANEL_SELECTOR + '.active');
  }

  function closePanels() {
    Array.prototype.forEach.call(openPanels(), function (panel) {
      panel.classList.remove('active');
    });

    Array.prototype.forEach.call(
      document.querySelectorAll('.cart_action_drawer_overlay.active'),
      function (overlay) {
        overlay.classList.remove('active');
      }
    );
  }

  function onDocumentClick(event) {
    if (!openPanels().length) return;

    var target = event.target;
    if (!target || !target.closest) return;
    if (target.closest(PANEL_SELECTOR)) return;
    if (target.closest(OPEN_BUTTON_SELECTOR)) return;

    closePanels();
  }

  /* Escape inchide intai panoul, si abia a doua oara drawerul. Fara oprirea
     propagarii, aceeasi apasare ar ajunge si la ascultatorul temei si ar inchide
     tot, adica ai pierde cosul din vedere fiindca ai vrut sa renunti la o nota. */
  function onKeyup(event) {
    if (event.key !== 'Escape' && event.code !== 'Escape') return;
    if (!openPanels().length) return;

    event.stopPropagation();
    closePanels();
  }

  function start() {
    document.addEventListener('click', onDocumentClick);
    document.addEventListener('keyup', onKeyup, true);

    var items = document.getElementById(ITEMS_ID);
    if (!items || typeof MutationObserver === 'undefined') return;

    new MutationObserver(scheduleRefresh).observe(items, { childList: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
